import {colorMap} from "./colors";


const fillColor =
    ['match',
      [
        'ceil',
        ['/', ['get', 'imd19_per'], 10]
      ],
        ...colorMap.flat(),
        'gray'
    ];

console.log({fillColor})

export default {
  layer: {
    id: "imd",
    "source-layer": "evlayers", // TOOD: fixme
    type: "fill",
    paint: {
      "fill-color": fillColor,
      "fill-opacity": 0.7,
      "fill-outline-color": 'black',
    },
    layout: {
      visibility: "none",
    },
  },
  source: {
    id: "imd",
    'type': 'vector',
    'tiles': ["https://d1lfm2zniswzpu.cloudfront.net/ev-layers/{z}/{x}/{y}.mvt"],
    'minzoom': 6,
    'maxzoom': 14
  },
  labels: {
    parent: "Index of Multiple Deprivation (IMD)",
  },
  filters: {
    filterByChildren: false,
  },
  filterBySelectedRegion: false,
  category: "hsds",
  noColourPicker: true,
  toggleColor: "lightgrey",
      popupAttributes: ["imd19_per"],

}





